<template>
  <v-container>
    <div id="grupoProdutosId">
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div
        v-else
      >
        <div
          id="idTable"
          style="overflow-x: auto; max-width: 100%;"
        >
          <table
            style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
            class="elevation-1"
          >
            <thead>
              <tr>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Vendedor
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Faturamento
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Devolução
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Comissão
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  % Comissão
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in faturamentoPromisaoComissao"
                :key="item.id"
              >
                <td
                  id="dadoMovimentacao"
                  style="text-align: left;"
                >
                  {{ item.vendedor }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                  :style="styleObjectFaturamento"
                >
                  {{ item.faturamento }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                  :style="styleObjectDevolucao"
                >
                  {{ item.devolucao }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                  :style="styleObject"
                >
                  {{ item.comissao }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                  :style="styleObject"
                >
                  {{ item.porcentagem }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
  import Comercial from '../../../../../services/comercialpersonalizacao'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowPovisaoComissao',
    emits: [],
    components: {
    },
    data: () => ({
      styleObjectFaturamento: {
        color: '#4CAF50',
      },
      styleObjectDevolucao: {
        color: '#F44336',
      },
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      date: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      vendedor: [],
      headersPromisaoComissao: [
        { text: 'Vendedor', value: 'vendedor', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', align: 'right', class: 'black--text title' },
        { text: 'Devolução', value: 'devolucao', align: 'right', class: 'black--text title' },
        { text: 'Comissão', value: 'comissao', align: 'right', class: 'black--text title' },
        { text: '$ Comissão', value: 'porcentagem', align: 'right', class: 'black--text title' },
      ],
      faturamentoPromisaoComissao: [],
    }),

    created () {
      eventEmit.$on('update-form-vendedores', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-form-vendedores', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, vendedor) {
        this.primeiroDia = primeiroDia
        this.date = dataFinal
        this.select = select
        this.vendedor = vendedor

        this.showDadosProvisaoComissao()
      },

      async showDadosProvisaoComissao () {
        this.loading = true

        this.faturamentoPromisaoComissao = []

        await Comercial.showProvisaoComissao(this.primeiroDia, this.date, this.select, this.vendedor, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.faturamentoPromisaoComissao = resposta.data.dados.map((item) => {
              var listaFaturamento = ({
                vendedor: item.vendedor,
                faturamento: item.faturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                devolucao: item.devolucao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                comissao: item.comissao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                porcentagem: item.porcentagem.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
              })

              return listaFaturamento
            })
          } else if (resposta.data.msg === 'Não há dados no período selecionado') {
            this.faturamentoPromisaoComissao = []
            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
      max-width: 395px !important;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {

  }
</style>

<style lang="sass">
  #idPC
    font-weight: bold
</style>
